import { render, staticRenderFns } from "./ShareGoodsDetail.vue?vue&type=template&id=52790764&scoped=true"
import script from "./ShareGoodsDetail.vue?vue&type=script&lang=ts"
export * from "./ShareGoodsDetail.vue?vue&type=script&lang=ts"
import style0 from "./ShareGoodsDetail.vue?vue&type=style&index=0&id=52790764&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52790764",
  null
  
)

export default component.exports